// import React, { useState, useEffect } from 'react';
// import {
//     Plus, Save, Download, Calculator,
//     FileText, Building, User, Calendar
// } from 'lucide-react';
// import { Button } from './Button';
// import FormField from './ui/FormField';

// export const InvoiceGenerator = () => {
//     const [invoiceData, setInvoiceData] = useState({
//         invoiceDate: new Date().toISOString().split('T')[0],
//         invoiceNumber: '',
//         billTo: '',
//         billToGSTIN: '',
//         shipTo: '',
//         placeOfSupply: '',
//         sellerGSTIN: '27AAAAA0000A1Z5',
//         sellerState: 'Maharashtra',
//         dueDate: '',
//         tdsReceivable: 0,
//         tcsReceivable: 0,
//         narration: '',
//         voucherTypeName: 'Sales Invoice',
//         items: []
//     });

//     const [newItem, setNewItem] = useState({
//         productName: '',
//         costCentre: '',
//         hsnSacCode: '',
//         quantity: 1,
//         rate: 0,
//         discount: 0,
//         taxabilityType: 'Taxable',
//         gstRate: 18,
//         cessAmt: 0
//     });

//     const states = [ /* same list as before */];

//     const gstRates = [0, 5, 12, 18, 28];

//     const getStateFromGSTIN = (gstin) => {
//         if (!gstin || gstin.length < 2) return '';
//         const stateCode = gstin.substring(0, 2);
//         const stateMap = {
//             '01': 'Jammu and Kashmir', '02': 'Himachal Pradesh',
//             '03': 'Punjab', '04': 'Chandigarh', '05': 'Uttarakhand',
//             '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
//             '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim',
//             '12': 'Arunachal Pradesh', '13': 'Nagaland', '14': 'Manipur',
//             '15': 'Mizoram', '16': 'Tripura', '17': 'Meghalaya',
//             '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
//             '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh',
//             '24': 'Gujarat', '25': 'Daman and Diu', '26': 'Dadra and Nagar Haveli',
//             '27': 'Maharashtra', '28': 'Andhra Pradesh', '29': 'Karnataka',
//             '30': 'Goa', '31': 'Lakshadweep', '32': 'Kerala',
//             '33': 'Tamil Nadu', '34': 'Puducherry', '35': 'Andaman and Nicobar Islands',
//             '36': 'Telangana'
//         };
//         return stateMap[stateCode] || '';
//     };

//     const calculateItemValues = (item) => {
//         const qty = item.quantity || 0;
//         const rate = item.rate || 0;
//         const discount = item.discount || 0;
//         const gstRate = item.gstRate || 0;
//         const discountAmount = (rate * qty * discount) / 100;
//         const taxableValue = (rate * qty) - discountAmount;
//         let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;
//         if (item.taxabilityType === 'Taxable' && gstRate > 0) {
//             const isInterState = invoiceData.sellerState !== getStateFromGSTIN(invoiceData.billToGSTIN);
//             if (isInterState) {
//                 igstAmt = taxableValue * gstRate / 100;
//             } else {
//                 cgstAmt = taxableValue * gstRate / 200;
//                 sgstAmt = taxableValue * gstRate / 200;
//             }
//         }
//         const cessAmt = item.cessAmt || 0;
//         const totalValue = taxableValue + cgstAmt + sgstAmt + igstAmt + cessAmt;
//         return { discountAmount, taxableValue, cgstAmt, sgstAmt, igstAmt, cessAmt, totalValue };
//     };

//     const addItem = () => {
//         if (!newItem.productName || !newItem.rate) return;
//         const vals = calculateItemValues(newItem);
//         const item = {
//             id: Date.now().toString(),
//             productName: newItem.productName,
//             costCentre: newItem.costCentre || '',
//             hsnSacCode: newItem.hsnSacCode || '',
//             quantity: newItem.quantity,
//             rate: newItem.rate,
//             discount: newItem.discount,
//             taxabilityType: newItem.taxabilityType,
//             gstRate: newItem.gstRate,
//             cessAmt: newItem.cessAmt,
//             ...vals
//         };
//         setInvoiceData(prev => ({ ...prev, items: [...prev.items, item] }));
//         setNewItem({
//             productName: '', costCentre: '', hsnSacCode: '',
//             quantity: 1, rate: 0, discount: 0, taxabilityType: 'Taxable',
//             gstRate: 18, cessAmt: 0
//         });
//     };

//     const removeItem = id => {
//         setInvoiceData(prev => ({ ...prev, items: prev.items.filter(i => i.id !== id) }));
//     };

//     const calculateTotals = () => {
//         return invoiceData.items.reduce((acc, item) => {
//             acc.totalTaxableValue += item.taxableValue;
//             acc.totalCGST += item.cgstAmt;
//             acc.totalSGST += item.sgstAmt;
//             acc.totalIGST += item.igstAmt;
//             acc.totalCess += item.cessAmt;
//             acc.totalInvoiceValue += item.totalValue;
//             return acc;
//         }, { totalTaxableValue: 0, totalCGST: 0, totalSGST: 0, totalIGST: 0, totalCess: 0, totalInvoiceValue: 0 });
//     };

//     const totals = calculateTotals();

//     const generateInvoiceNumber = () => {
//         const d = new Date(), yy = d.getFullYear().toString().slice(-2);
//         const mm = (d.getMonth() + 1).toString().padStart(2, '0');
//         const rnd = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
//         return `INV${yy}${mm}${rnd}`;
//     };

//     useEffect(() => {
//         if (!invoiceData.invoiceNumber) {
//             setInvoiceData(prev => ({ ...prev, invoiceNumber: generateInvoiceNumber() }));
//         }
//     }, []);

//     return (
//         <div className="space-y-6">
//             {/* Header */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//                 <div className="flex items-center justify-between mb-6">
//                     <h1 className="text-2xl font-bold">Smart Invoice Generator</h1>
//                     <div className="flex space-x-3">

//                         <Button label="Save Draft" />
//                         <Button label="Generate Invoice" />
//                     </div>
//                 </div>
//             </div>

//             {/* Invoice Header Information */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                 <div className="space-y-4">
//                     <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
//                         <FileText className="h-5 w-5" />
//                         <span>Invoice Details</span>
//                     </h3>
//                     <div className="space-y-3">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Date</label>
//                             <input
//                                 type="date"
//                                 value={invoiceData.invoiceDate}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, invoiceDate: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Number</label>
//                             <input
//                                 type="text"
//                                 value={invoiceData.invoiceNumber}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, invoiceNumber: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Due Date</label>
//                             <input
//                                 type="date"
//                                 value={invoiceData.dueDate}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, dueDate: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 <div className="space-y-4">
//                     <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
//                         <User className="h-5 w-5" />
//                         <span>Bill To</span>
//                     </h3>
//                     <div className="space-y-3">
//                         {/* <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Bill To</label>
//                             <input
//                                 type="text"
//                                 value={invoiceData.billTo}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, billTo: e.target.value }))}
//                                 placeholder="Customer Name"
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div> */}
//                         <FormField
//                             label="Bill To"
//                             type="string"
//                             value={invoiceData.billTo}
//                             onChange={(val) =>
//                                 setInvoiceData((prev) => ({ ...prev, billTo: val }))
//                             }
//                             placeholder="Customer Name"
//                         />
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Bill To GSTIN</label>
//                             <input
//                                 type="text"
//                                 value={invoiceData.billToGSTIN}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, billToGSTIN: e.target.value }))}
//                                 placeholder="Customer GSTIN"
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Ship To</label>
//                             <input
//                                 type="text"
//                                 value={invoiceData.shipTo}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, shipTo: e.target.value }))}
//                                 placeholder="Shipping Address"
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 <div className="space-y-4">
//                     <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
//                         <Building className="h-5 w-5" />
//                         <span>Seller Details</span>
//                     </h3>
//                     <div className="space-y-3">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Seller GSTIN</label>
//                             <input
//                                 type="text"
//                                 value={invoiceData.sellerGSTIN}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, sellerGSTIN: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Seller State</label>
//                             <select
//                                 value={invoiceData.sellerState}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, sellerState: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             >
//                                 {states.map(state => (
//                                     <option key={state} value={state}>{state}</option>
//                                 ))}
//                             </select>
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Place of Supply</label>
//                             <select
//                                 value={invoiceData.placeOfSupply}
//                                 onChange={(e) => setInvoiceData(prev => ({ ...prev, placeOfSupply: e.target.value }))}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             >
//                                 <option value="">Select Place of Supply</option>
//                                 {states.map(state => (
//                                     <option key={state} value={state}>{state}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Add Item Section */}
//             <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">Add Invoice Item</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4">
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
//                         <input
//                             type="text"
//                             value={newItem.productName || ''}
//                             onChange={(e) => setNewItem(prev => ({ ...prev, productName: e.target.value }))}
//                             placeholder="Product/Service Name"
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">HSN/SAC Code</label>
//                         <input
//                             type="text"
//                             value={newItem.hsnSacCode || ''}
//                             onChange={(e) => setNewItem(prev => ({ ...prev, hsnSacCode: e.target.value }))}
//                             placeholder="HSN/SAC"
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Quantity</label>
//                         <input
//                             type="number"
//                             value={newItem.quantity || 1}
//                             onChange={(e) => setNewItem(prev => ({ ...prev, quantity: parseFloat(e.target.value) || 1 }))}
//                             min="0"
//                             step="0.01"
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Rate</label>
//                         <input
//                             type="number"
//                             value={newItem.rate || 0}
//                             onChange={(e) => setNewItem(prev => ({ ...prev, rate: parseFloat(e.target.value) || 0 }))}
//                             min="0"
//                             step="0.01"
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">GST Rate (%)</label>
//                         <select
//                             value={newItem.gstRate || 18}
//                             onChange={(e) => setNewItem(prev => ({ ...prev, gstRate: parseFloat(e.target.value) }))}
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         >
//                             {gstRates.map(rate => (
//                                 <option key={rate} value={rate}>{rate}%</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex items-end">

//                         <Button label="Add Item" onClick={addItem} />

//                     </div>
//                 </div>

//                 {/* Live Calculation Preview */}
//                 {(newItem.rate && newItem.quantity) && (
//                     <div className="bg-gray-50 rounded-lg p-4">
//                         <h4 className="font-medium text-gray-900 mb-2">Live Calculation Preview</h4>
//                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
//                             <div>
//                                 <span className="text-gray-600">Taxable Value:</span>
//                                 <span className="font-medium ml-2">₹{calculateItemValues(newItem).taxableValue.toFixed(2)}</span>
//                             </div>
//                             <div>
//                                 <span className="text-gray-600">CGST:</span>
//                                 <span className="font-medium ml-2">₹{calculateItemValues(newItem).cgstAmt.toFixed(2)}</span>
//                             </div>
//                             <div>
//                                 <span className="text-gray-600">SGST:</span>
//                                 <span className="font-medium ml-2">₹{calculateItemValues(newItem).sgstAmt.toFixed(2)}</span>
//                             </div>
//                             <div>
//                                 <span className="text-gray-600">IGST:</span>
//                                 <span className="font-medium ml-2">₹{calculateItemValues(newItem).igstAmt.toFixed(2)}</span>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* Invoice Items Table */}
//             {invoiceData.items.length > 0 && (
//                 <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//                     <div className="p-6 border-b border-gray-200">
//                         <h3 className="text-lg font-semibold text-gray-900">Invoice Items</h3>
//                     </div>
//                     <div className="overflow-x-auto">
//                         <table className="min-w-full divide-y divide-gray-200">
//                             <thead className="bg-gray-50">
//                                 <tr>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">HSN/SAC</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rate</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxable Value</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">CGST</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SGST</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">IGST</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody className="bg-white divide-y divide-gray-200">
//                                 {invoiceData.items.map((item) => (
//                                     <tr key={item.id} className="hover:bg-gray-50">
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.productName}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.hsnSacCode}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.quantity}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{item.rate.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{item.taxableValue.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{item.cgstAmt.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{item.sgstAmt.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{item.igstAmt.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">₹{item.totalValue.toFixed(2)}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                             <button
//                                                 onClick={() => removeItem(item.id)}
//                                                 className="text-red-600 hover:text-red-900"
//                                             >
//                                                 Remove
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             )}

//             {/* Invoice Summary */}
//             {invoiceData.items.length > 0 && (
//                 <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//                     <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
//                         <Calculator className="h-5 w-5" />
//                         <span>Invoice Summary</span>
//                     </h3>
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         <div className="space-y-3">
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Total Taxable Value:</span>
//                                 <span className="font-medium">₹{totals.totalTaxableValue.toFixed(2)}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Total CGST:</span>
//                                 <span className="font-medium">₹{totals.totalCGST.toFixed(2)}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Total SGST:</span>
//                                 <span className="font-medium">₹{totals.totalSGST.toFixed(2)}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Total IGST:</span>
//                                 <span className="font-medium">₹{totals.totalIGST.toFixed(2)}</span>
//                             </div>
//                         </div>
//                         <div className="space-y-3">
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">TDS Receivable:</span>
//                                 <input
//                                     type="number"
//                                     value={invoiceData.tdsReceivable}
//                                     onChange={(e) => setInvoiceData(prev => ({ ...prev, tdsReceivable: parseFloat(e.target.value) || 0 }))}
//                                     className="w-24 px-2 py-1 border border-gray-300 rounded text-right"
//                                     step="0.01"
//                                 />
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">TCS Receivable:</span>
//                                 <input
//                                     type="number"
//                                     value={invoiceData.tcsReceivable}
//                                     onChange={(e) => setInvoiceData(prev => ({ ...prev, tcsReceivable: parseFloat(e.target.value) || 0 }))}
//                                     className="w-24 px-2 py-1 border border-gray-300 rounded text-right"
//                                     step="0.01"
//                                 />
//                             </div>
//                             <div className="flex justify-between text-lg font-bold border-t pt-3">
//                                 <span>Total Invoice Value:</span>
//                                 <span>₹{(totals.totalInvoiceValue + invoiceData.tdsReceivable + invoiceData.tcsReceivable).toFixed(2)}</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="mt-6">
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Narration</label>
//                         <textarea
//                             value={invoiceData.narration}
//                             onChange={(e) => setInvoiceData(prev => ({ ...prev, narration: e.target.value }))}
//                             placeholder="Additional notes or terms..."
//                             rows={3}
//                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };


import React from 'react'
import Invoice from '../pages/invoice/Invoice'

export  const InvoiceGenerator = () => {
  return (
    <>
    
    <Invoice/>
    </>
  )
}
